module.exports = __webpack_public_path__ + "static/media/Logo.5f866471.png";